import { makeToast, removeToast } from "./toast.store";

// TOOD: This doesn't need to be a hook, would require refactoring usages of useToast
const useToast = () => {
  return { makeToast, removeToast };
};

export { useToast };
